// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ArtifactPaneCloseButton.test.tsx
import { X } from "@phosphor-icons/react";

import { PANE_HEADER_ICON_SIZE, PaneHeaderIconButton } from "./PaneHeader";

/**
 * Leading close control shared by project review screens and standalone chat
 * artifact viewers. Uses the canonical pane-header size-7 / icon-14 chrome so
 * it matches collapse, prev/next, and add-comment controls.
 */
export function ArtifactPaneCloseButton({
  onClick,
  "data-testid": testId = "chat-artifact-viewer-close",
  ariaLabel,
}: {
  onClick: () => void;
  "data-testid"?: string;
  ariaLabel: string;
}) {
  return (
    <PaneHeaderIconButton
      onClick={onClick}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      <X size={PANE_HEADER_ICON_SIZE} aria-hidden="true" />
    </PaneHeaderIconButton>
  );
}
